import React, { useState, useContext } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Header, Button } from "semantic-ui-react";
import TextInput from "../../app/common/form/TextInput";
import { RootStoreContext } from "../../app/stores/rootStore";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
} from "revalidate";

function SendEmailResetPassword() {
  //variables para uso la informacion del userStore
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { sendReset } = rootStore.userStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [data] = useState({
    username: "",
  });

  const validate = combineValidators({
    username: composeValidators(
      isRequired({ message: "Usuario de acceso no puede estar vacío" }),
      hasLengthGreaterThan(3)({
        message: "El Usuario de acceso debe tener al menos 4 caracteres",
      })
    )(),
  });

  const handleFinalFormSubmit = (value: any) => {
    sendReset(value.username);
  };

  return (
    <div>
      <FinalForm
          initialValues={data}
          validate={validate}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Container textAlign="justified">
                <p style={{ textAlign: "justify", hyphens: "none" }}>Confirma tu usuario de acceso para recuperar la contraseña. Recibirás un correo electrónico, en caso que no llegue no olvides revisar la carpeta spam.</p>
              </Container>

              <Header as="h2" icon textAlign="center">
                <h2>Usuario de acceso</h2>
              </Header>

              <Field
                name="username"
                placeholder="Usuario de acceso"
                value={data.username}
                component={TextInput}
              />
              <Container textAlign="center">
                <br />
                <Button
                  loading={loading}
                  disabled={loading}
                  className="ui primary button"
                  color="blue"
                  type="submit"
                  content="Recordar"
                />
              </Container>
            </Form>
          )}
        />
    </div>
  );
}

export default SendEmailResetPassword;
